import React from "react";
import { AssignedTeamCount } from "./chatAnalyticsService";

interface ChatTeamsSectionProps {
  teams: AssignedTeamCount[];
}

const ChatTeamsSection: React.FC<ChatTeamsSectionProps> = ({ teams }) => {
  if (teams.length === 0) {
    return (
      <div className="text-center py-4">
        <i className="ti ti-users-group fs-1 text-muted mb-2" />
        <p className="mb-1 fw-medium">No chats have been routed to a team yet</p>
        <p className="text-muted fs-12 mb-0">
          No teams are set up yet
        </p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table ca-agent-table mb-0">
        <thead>
          <tr>
            <th>Assigned Team</th>
            <th className="text-center">Total Chats</th>
            <th className="text-center">Total Messages</th>
            <th className="text-center">Agent Replies</th>
            <th className="text-center">Bot Replies</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team, index) => (
            <tr key={`${team.team_id || team.assigned_team_name}-${index}`}>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <span className="ca-avatar-img d-flex align-items-center justify-content-center bg-primary-transparent text-primary fw-semibold" style={{ width: 32, height: 32, borderRadius: '50%' }}>
                    {team.assigned_team_name.charAt(0).toUpperCase()}
                  </span>
                  {team.assigned_team_name}
                </div>
              </td>
              <td className="text-center num">{team.total_chats}</td>
              <td className="text-center num">{team.total_messages}</td>
              <td className="text-center num">{team.total_agent_replies}</td>
              <td className="text-center num">{team.total_bot_replies}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ChatTeamsSection;
